import React, {useEffect, useRef, useState} from 'react';
import Layout from '../Shared/Layout';
import {Container, Divider, Grid, makeStyles} from "@material-ui/core";
import styled from "styled-components";
import FormPage from "../Shared/FormPage";
import {InertiaLink} from "@inertiajs/inertia-react";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import TextField from "@material-ui/core/TextField";
import StatusFlow from "../Shared/StatusFlow/StatusFlow";
import MuiButton from "@material-ui/core/Button";
import BackButton from "../Shared/BackButton";
import {getCookieValue} from "../utils/getCookieValue";
import { Trans } from "../utils/i18n";
import {Alert} from "@material-ui/lab";
import Button from "@material-ui/core/Button";

const Card = styled.a`
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  text-align: center;
  padding: 30px;
  font-size: 20px;
  display: block;
  text-decoration: none;
  color: ${props => props.theme.text};
`;

const Wrapper = styled.div`
`;

const useStyles = makeStyles({
    root: {
        fontSize: '18px',
        padding: '10px 22px',
        width: '100%',
    },
});

//  Demo video = "https://unzer.demo.b1t5.io/demo/LDdw7Xd1?embed=true"
const VideoEmbed = ({ src, title = "b1t5.io video player" }) => {
    return (
      <div style={{ position: "relative", overflow: "hidden", width: "100%", paddingTop: "56.25%" }}>
        <iframe
          style={{ position: "absolute", top: 0, left: 0, bottom: 0, right: 0, width: "100%", height: "100%" }}
          src={src}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </div>
    );
};

export default function TrackAndTrace({ requesttypes, products, user }) {
    const [serialNumber, setSerialNumber] = useState('');
    const [data, setData] = useState(null);
    const classes = useStyles();
    const flowsRef = useRef();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const serialnumber = params.get('serialnumber');
        setSerialNumber(serialnumber);
        fetchData(serialnumber)

    }, [window.location.search]);

    const fetchData = (postData) => {
        fetch(route('track.search'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
                number: postData,
            })
        })
            .then(response => response.json())
            .then(data => {
                if(!data.success) {
                    throw 'error';
                }

                setData(data);
                flowsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', });
            })
            .catch((data) => {
                setData(data);
            })
    };

    const handleKeyDown = (event) => {
        if (event.key !== 'Enter' && event.key !== undefined) {
            return;
        }
        setData(null);

        fetchData(serialNumber);
        event.preventDefault();
    };

    const onChange = (e) => {
        setSerialNumber(e.target.value);
    };

    return (
        <Wrapper>
            <Container maxWidth="lg">

                <Grid container spacing={3}>
                    <Grid item xs={12} sm={7}>
                        { user ? (
                            <BackButton />
                        ) : (
                            <BackButton href={route('home')} label={<Trans i18nKey="common.home">Home</Trans>} />
                        )}
                        <h1><Trans i18nKey="trackAndTrace">Track and Trace</Trans></h1>

                        {/* <div style={{ marginBottom: 30, marginTop: 30}}>

                            <Alert severity="info"
                                   action={
                                       <Button color={'secondary'} size="small">
                                           <span style={{ color: '#000000'}}>Return service buchen</span>
                                       </Button>
                                   }
                            >Sie können für diesen Auftrag einen Return Service buchen</Alert>
                        </div> */}

                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    label={<Trans i18nKey="trackAndTrace.textFieldLabel">Enter RMA, Order or Serial number</Trans>}
                                    name={'serialNumber'}
                                    type={'text'}
                                    // helperText={touched && error }
                                    onChange={onChange}
                                    inputProps={{
                                        onKeyDown: handleKeyDown,
                                    }}
                                    variant="outlined"
                                    value={serialNumber}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <MuiButton
                                    variant="contained"
                                    color={'secondary'}
                                    size={'large'}
                                    onClick={handleKeyDown}
                                    className={classes.root}
                                >
                                    <Trans i18nKey="trackAndTrace.search">SEARCH</Trans>
                                </MuiButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <div style={{ margin: '60px 0 40px'}}>
                    <Divider ref={flowsRef} />
                </div>

                {
                    data && data !== 'error' && 
                    <div>
                        
                        {
                            data?.video &&
                            <>
                                <VideoEmbed src={data?.video} />
                                <div style={{ margin: '60px 0 40px'}}>
                                    <Divider/>
                                </div>
                            </>
                        }

                        <StatusFlow data={data} />
                    </div>
                }

                {
                    data && data === 'error' && <div>
                        <Trans i18nKey="trackAndTrace.errorMessage">No order found for this serial number</Trans>
                    </div>
                }

            </Container>
        </Wrapper>
    )
}

TrackAndTrace.layout = page => <Layout children={page} />;
